import { createContext } from "react";

import { MenuProps } from "../Menu";

/**
 * Context props for Menu components
 */
export type MenuContextProps = {
  /**
   * Function to close the root menu
   */
  closeRootMenu: () => void;
  /**
   * Whether auto height is disabled
   */
  disableAutoHeight: MenuProps["disableAutoHeight"];
};
export const MenuContext = createContext<MenuContextProps | null>(null);
